import { render } from "./AboutusView.vue?vue&type=template&id=1caa5924"
import script from "./AboutusView.vue?vue&type=script&lang=js"
export * from "./AboutusView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__